import React, {memo, useState} from 'react';
import RedesignAddPaymentMethodSetup from "../../views/RedesignAddPaymentMethodSetup";
import {Account} from "../../types/Account";

interface AddPaymentMethodFlowManagerProps {
  account: Account;
  open: boolean;
  setOpen: (open: boolean) => void;
  loadPaymentMethods: () => void;
}

const AddPaymentMethodFlowManager = memo(({account, open, setOpen, loadPaymentMethods}: AddPaymentMethodFlowManagerProps) => {
  const [isACHPaymentMethod, setIsACHPaymentMethod] = useState(false);
  const [isMicroDepositPaymentMethod, setIsMicroDepositPaymentMethod] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleACHChange = (value: boolean) => {
    setIsACHPaymentMethod(value);
    setIsMicroDepositPaymentMethod(false);
  }

  return (
    <RedesignAddPaymentMethodSetup
      account={account}
      doneWithAddPaymentMethod={handleClose}
      payWithAch={isACHPaymentMethod}
      loadPaymentMethods={loadPaymentMethods}
      paymentModalOpen={open}
      setPaymentModalOpen={setOpen}
      setACH={handleACHChange}
      setMicroDeposit={setIsMicroDepositPaymentMethod}
      microDepositVerify={isMicroDepositPaymentMethod}
      collectMicroDepositVerifyPayment={isMicroDepositPaymentMethod}
    />
  )
});

AddPaymentMethodFlowManager.displayName = "AddPaymentMethodFlowManager";

export default AddPaymentMethodFlowManager;